import { Box, ClickAwayListener, Paper, Popper } from "@mui/material";
import { Dispatch, SetStateAction, useRef, useState } from "react";

type CustomPopoverProps = {
  trigger: React.ReactNode;
  children: React.ReactNode;
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  padding?: string;
  maxWidth?: string;
};

export const ArrowPopper = ({
  trigger,
  children,
  padding = "20px",
  maxWidth = "320px",
  open,
  setOpen,
}: CustomPopoverProps) => {
  const anchorRef = useRef<HTMLDivElement | null>(null);
  const [arrowRef, setArrowRef] = useState<HTMLElement | null>(null);

  return (
    <>
      <div ref={anchorRef} onClick={() => setOpen((prev) => !prev)}>
        {trigger}
      </div>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        placement="bottom-start"
        modifiers={[
          {
            name: "arrow",
            enabled: true,
            options: {
              element: arrowRef,
            },
          },
          {
            name: "offset",
            options: {
              offset: [-10, 12],
            },
          },
        ]}
        sx={{ zIndex: 1300 }}
      >
        <ClickAwayListener onClickAway={() => setOpen(false)}>
          <Box sx={{ position: "relative" }}>
            {/* 🔺 Стрелочка */}
            <Box
              ref={setArrowRef}
              sx={{
                position: "absolute",
                width: 20,
                height: 10,
                top: -10,
                left: "calc(50% - 10px)",
                overflow: "hidden",
                zIndex: 1,
              }}
            >
              <Box
                sx={{
                  width: 14,
                  height: 14,
                  backgroundColor: "var(--popover-bg, white)",
                  transform: "rotate(45deg)",
                  margin: "auto",
                  mt: "6px",
                  boxShadow: 2,
                  borderRadius: "2px",
                }}
              />
            </Box>

            <Paper
              sx={{
                p: 2,
                borderRadius: "20px",
                boxShadow: 4,
                backgroundColor: "var(--popover-bg, #fff)",
                color: "var(--popover-text, inherit)",
                zIndex: 1,
                padding: padding,
                maxWidth: maxWidth,
              }}
            >
              {children}
            </Paper>
          </Box>
        </ClickAwayListener>
      </Popper>
    </>
  );
};
